export enum ExamRequirementTab {
  DEFAULT_EXAM_REQUIREMENTS = "default-exam-requirements",
  EXPIRING_SOON = "expiring-soon"
}

export const examRequirementTabLabels: Record<ExamRequirementTab, string> = {
  [ExamRequirementTab.DEFAULT_EXAM_REQUIREMENTS]:
    "Entry & Workout Exams - Forms Needed",
  [ExamRequirementTab.EXPIRING_SOON]: "Expiring Soon"
};

export const mobileExamRequirementTabLabels: Record<
  ExamRequirementTab,
  string
> = {
  [ExamRequirementTab.DEFAULT_EXAM_REQUIREMENTS]: "Needed",
  [ExamRequirementTab.EXPIRING_SOON]: "Expiring Soon"
};
